import React from "react"
import Skill from "./skill"
import { ProfileType } from "../../types"
import "./skills.css"


const Skills = ({ skills }) => (
  <>
    <h5 className="font-header font-semibold text-front uppercase skillfont" style = {{marginBottom:20}}>
      Core Languages
    </h5>
    <ul className="flex flex-wrap grid grid-cols-3 gap-2 md:gap-4 ">
      {skills.map((skill, i) => (
        <Skill skill={skill} key={skill} i={i + 1} />
      ))}
    </ul>
    <h5 className="font-header font-semibold text-front uppercase skillfont" style = {{marginTop:20,marginBottom:20}}>
      Cybersecurity Acknowledgements
    </h5>
    <p>Below are some of the top companies who acknowledged me for securing their products.</p>
    <div class="cards"><img src="https://i.postimg.cc/fby4pYFt/meta.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/DzvfZWNn/mastercard.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/7LRLWHB4/twitter.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/JnCfnS0J/automattic.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/P5zFty9V/Hubspot.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/CxNmy1nW/outreach.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/brcQSc2x/b-h-photo-video.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/TYKCzCYX/ziffdavis.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/CM71qpDw/bigcommerce.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/k5qz8zWd/aircall.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/5NwMCwDL/ecommpay.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/50FrMJVL/skroutz.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/6qZTR8Nq/toyota.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/rsRRJh58/Huawei.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/1tTm5s2H/shutterfly.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/8PkGQF7S/takeaway.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/8Cpk7cKS/Unilever.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/G28FpPqs/nvidia.png"/></div>
    <div class="cards"><img src="https://i.postimg.cc/QtqxXY0t/microsoft.png"/></div>


  </>
)

Skills.propTypes = {
  skills: ProfileType.skills,
}

export default Skills
